export const OPEN_UPDATE_JOB_ALERT_MODAL = 'OPEN_UPDATE_JOB_ALERT_MODAL'
export const CLOSE_UPDATE_JOB_ALERT_MODAL = 'CLOSE_UPDATE_JOB_ALERT_MODAL'
